/**
 * Azuki (TVP Backend) request endpoints.
 * @internal
 */
export const MKAzukiRequestEndpoint = {
    /**
     * API version.
     */
    API_REQUEST_VERSION: "v1",

    /**
     * API request type (client or server).
     */
    API_REQUEST_TYPE: "client",

    /**
     * Registration API.
     */
    REGISTRATION: {
        API: "registrations",
        get(baseUrl: string): string {
            const endpointPath = `${MKAzukiRequestEndpoint.API_REQUEST_VERSION}/${MKAzukiRequestEndpoint.API_REQUEST_TYPE}/${MKAzukiRequestEndpoint.REGISTRATION.API}`
            if (!!baseUrl) {
                return `${baseUrl}/${endpointPath}`;
            }
            return endpointPath;
        }
    },

    /**
     * Roll API.
     */
    ROLL: {
        API: "roll",
        get(baseUrl: string): string {
            const endpointPath = `${MKAzukiRequestEndpoint.API_REQUEST_VERSION}/${MKAzukiRequestEndpoint.API_REQUEST_TYPE}/${MKAzukiRequestEndpoint.ROLL.API}`
            if (!!baseUrl) {
                return `${baseUrl}/${endpointPath}`;
            }
            return endpointPath;
        }
    },

    /**
     * Beacons API.
     */
    BEACONS: {
        API: "beacons",
        get(baseUrl: string): string {
            const endpointPath = `${MKAzukiRequestEndpoint.API_REQUEST_VERSION}/${MKAzukiRequestEndpoint.API_REQUEST_TYPE}/${MKAzukiRequestEndpoint.BEACONS.API}`
            if (!!baseUrl) {
                return `${baseUrl}/${endpointPath}`;
            }
            return endpointPath;
        }
    },

    /**
     * Query API.
     */
    QUERY: {
        API: "query",
        get(baseUrl: string): string {
            const endpointPath = `${MKAzukiRequestEndpoint.API_REQUEST_VERSION}/${MKAzukiRequestEndpoint.API_REQUEST_TYPE}/${MKAzukiRequestEndpoint.QUERY.API}`
            if (!!baseUrl) {
                return `${baseUrl}/${endpointPath}`;
            }
            return endpointPath;
        }
    },

    /**
     * Widevine license API.
     */
    WV_LICENSE: {
        API: "get-widevine-license",
        get(baseUrl: string): string {
            const endpointPath = `${MKAzukiRequestEndpoint.API_REQUEST_VERSION}/${MKAzukiRequestEndpoint.API_REQUEST_TYPE}/${MKAzukiRequestEndpoint.WV_LICENSE.API}`
            if (!!baseUrl) {
                return `${baseUrl}/${endpointPath}`;
            }
            return endpointPath;
        }
    },

    /**
     * Playready license API.
     */
    PR_LICENSE: {
        API: "get-playready-license",
        get(baseUrl: string): string {
            const endpointPath = `${MKAzukiRequestEndpoint.API_REQUEST_VERSION}/${MKAzukiRequestEndpoint.API_REQUEST_TYPE}/${MKAzukiRequestEndpoint.PR_LICENSE.API}`
            if (!!baseUrl) {
                return `${baseUrl}/${endpointPath}`;
            }
            return endpointPath;
        }
    },

    /**
     * Fairplay license API.
     */
    FP_LICENSE: {
        API: "get-fairplay-license",
        get(baseUrl: string): string {
            const endpointPath = `${MKAzukiRequestEndpoint.API_REQUEST_VERSION}/${MKAzukiRequestEndpoint.API_REQUEST_TYPE}/${MKAzukiRequestEndpoint.FP_LICENSE.API}`
            if (!!baseUrl) {
                return `${baseUrl}/${endpointPath}`;
            }
            return endpointPath;
        }
    },

    /**
     * Fairplay certificate API.
     */
    FP_CERTIFICATE: {
        API: "get-fairplay-cert",
        get(baseUrl: string): string {
            const endpointPath = `${MKAzukiRequestEndpoint.API_REQUEST_VERSION}/${MKAzukiRequestEndpoint.API_REQUEST_TYPE}/${MKAzukiRequestEndpoint.FP_CERTIFICATE.API}`
            if (!!baseUrl) {
                return `${baseUrl}/${endpointPath}`;
            }
            return endpointPath;
        }
    }
};
Object.freeze(MKAzukiRequestEndpoint);